<template>
  <div id="hotel-room-dining-success" class="w-100 position-relative bg-green pb-5 overflow-hidden" style="height: 100vh;margin-bottom: -60px;z-index: 1040">
    <div class="text-right pt-3 px-4">
      <router-link :to="'/'+getMerchant().code+'/concierge/room-dining'">
        <img src="../../../../assets/img/icon/cancel.png" class="text-right" width="16">
      </router-link>
    </div>
    <div class="container position-relative text-center" style="top: 75px">
      <div class="rounded-100 size-icon mx-auto">
        <div class="bg-white rounded-100 size-icon-in">
          <img src="../../../../assets/img/icon/correct.png" width="40" style="margin: 20px 20px">
        </div>
      </div>
      <p class="mt-4 mb-0 heading-5-2 text-white">{{formatCurrency($route.query.total)}}</p>
      <!-- <p class="mt-2 mb-0 body-2-2" style="color: #FFFFFFA6">8 January 2020</p> -->
      <p class="sub-heading-1-2 text-white mt-4 mb-1 mb-0">{{$t('hotel.success.thanks-for-order')}}</p>
      <p class="body-2-4 text-white mt-0 mb-2">{{$t('hotel.concierge.your-order-will-be-delivered')}}</p>
      <router-link :to="'/'+getMerchant().code+'/concierge/order?reload=1'">
        <button class="btn button-primary bg-white text-green px-4 my-3">{{$t('hotel.concierge.order-history')}}</button>
      </router-link>
    </div>
    <div class="snow" style="top: 50px;left: 100px;background-color: #ffffff73"></div>
    <div class="snow" style="top: 200px;left: 320px;background-color: #cbcaca45;width: 12px;height: 12px"></div>
    <div class="snow" style="top: 256px;left: 55px;background-color: #cbcaca45;width: 12px;height: 12px"></div>
    <div class="snow" style="top: 500px;left: 75px;background-color: #ffffff73"></div>
    <div class="snow" style="top: 398px;left: 300px;background-color: #ffffff45;width: 12px;height: 12px"></div>
    <div class="snow" style="top: 570px;left: 260px;background-color: #ffffff45;width: 12px;height: 12px"></div>
    <div class="snow" style="top: 670px;left: 100px;background-color: #ffffff73;"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {formatCurrency} from '@/utils/index.js'

  export default{
    metaInfo(){
      return {
        title: 'Successfully Ordered',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    components: {
    },
    data() {
      return {
        scrollPosition: null,
      }
    },
    methods: {
      ...mapGetters(['getMerchant','getMetaTitleTemplate']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-room-dining-success').scrollIntoView({
        behavior: 'smooth'
      });
      if(this.$route.query.total == undefined){
        this.$router.push('/'+this.getMerchant().code+'/concierge/room-dining')
      }
    }
  }
</script>
<style scoped>
  
  .snow{
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
  }

  .size-icon {
    width: 85px;
    height: 85px;
    padding: 7px;
  }

  .size-icon-in {
    width: 80px;
    height: 80px
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
    -ms-overflow-style: none;
  }

  .height-img{
    height: 65px;
  }

  .note{
    margin-top: 0px;
  }

  .discon{
    margin-top: -8px;
  }

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/roomdining/RoomDiningSuccess.vue